import { ChartData } from '@/types';
import styles from './label.module.scss';

interface LabelProps extends Pick<ChartData, 'label'> {
  isFirstTab: boolean;
}

export const Label = ({ isFirstTab, label }: LabelProps) => {
  return (
    <div className={styles.label}>
      <div className={styles.label_container}>
        <div
          className={`${styles.label_wrapper} ${isFirstTab ? '' : styles.second}`}
        >
          <span>{label.credit}</span>
          <span>{label.income}</span>
        </div>
      </div>
    </div>
  );
};
